/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 28.08.2016.
 */
import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import DocumentTitle from 'react-document-title';
import Classnames from 'classnames';

import {SetLocalStorageValue, GetLocalStorageValue} from '../utils';
import {FetchAssetByIds} from '../actions/asset/action-asset';
import {GetAllRecords} from '../actions/npvr/action-npvr';
import Tooltip from 'rc-tooltip';
import Translate from '../components/Translate';

import ShowcaseNpvr from '../containers/ShowcaseNpvr';

import moment from 'moment';
import _get from 'lodash/get';
import _reverse from 'lodash/reverse';
import _sortBy from 'lodash/sortBy';
import _map from 'lodash/map';
import _uniq from 'lodash/uniq';
import _size from 'lodash/size';

import _isEqual from 'lodash/isEqual';
import _orderBy from 'lodash/orderBy';
import _groupBy from 'lodash/groupBy';
import _debounce from 'lodash/debounce';

const STATE_TO_TITLE = {
  0: 'Pending',
  1: 'In schedule',
  2: 'In progress',
  3: 'Finished',
  4: 'Failed',
  5: 'Canceled by user'
};

class NpvrRoute extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchTermInput: '',
      searchTerm: '',
      filterBy: GetLocalStorageValue('npvr-filter-sort', ['status', 'asc']),
      filters: ['status', 'date', 'alphabet', 'channel'],
      records: [],
      channelIds: []
    };

    this._setSearchTerm = _debounce(this._setSearchTerm.bind(this), 350);
  }

  componentWillMount() {

    this.props.GetAllRecords();
  }

  componentDidMount() {

    document.getElementById('npvr-search') && document.getElementById('npvr-search').focus();

    if (_size(this.props.channelIds)) {

      this.props.FetchAssetByIds(this.props.channelIds);
    }

    let newState = {};

    newState.records = _get(this.props, 'records', []).map((record) => {
      record.type = 'npvr';
      record._date = moment.unix(record.start_time || record.schedule_time).format('YYYYMMDD');
      record._letter = _get(record, 'epg_program.title', '#')[0];

      return record;
    });

    this.setState(newState);
  }

  componentWillReceiveProps(newPros) {
    let newState = {};

    newState.records = _get(newPros, 'records', []).map((record) => {
      record.type = 'npvr';
      record._date = moment.unix(record.start_time || record.schedule_time).format('YYYYMMDD');
      record._letter = _get(record, 'epg_program.title', '#')[0];

      return record;
    });

    if (!_isEqual(this.props.channelIds, newPros.channelIds)) {

      this.props.FetchAssetByIds(newPros.channelIds);
    }

    this.setState(newState);
  }

  _onSearchTermChange(event = {}) {

    this.setState({searchTermInput: _get(event, 'target.value', '')});
    this._setSearchTerm(_get(event, 'target.value', ''));
  }

  _setSearchTerm(text) {

    this.setState({searchTerm: text});
  }

  _setFilter(filter) {
    let filters = [filter];

    if (filter === this.state.filterBy[0]) {

      if (this.state.filterBy[1] === 'asc') filters.push('desc');
      if (this.state.filterBy[1] === 'desc') filters.push('asc');
    } else {

      filters.push(filter === 'date' ? 'desc' : 'asc');
    }

    SetLocalStorageValue('npvr-filter-sort', filters);

    this.setState({
      filterBy: filters
    })
  }

  __renderFilter(type) {
    switch (type) {
      case 'status': {

        return (<span className="switcher-icon">
          <i className="ic ic-status ic-24px"></i>
          {type === this.state.filterBy[0] &&
          <ReactCSSTransitionGroup transitionName="selection-animation" transitionAppear={true}
                                   transitionAppearTimeout={0} transitionEnterTimeout={0} transitionLeaveTimeout={0}>
            <i className="ic ic-selected-dot ic-10px selected-icon"></i>
          </ReactCSSTransitionGroup>}
          {type === this.state.filterBy[0] && this.state.filterBy[1] === 'asc' &&
          <i className="ic ic-sort-asc ic-10px sort-icon"></i>}
          {type === this.state.filterBy[0] && this.state.filterBy[1] === 'desc' &&
          <i className="ic ic-sort-desc ic-10px sort-icon"></i>}
        </span>);
      }

      case 'date': {

        return (
          <span className="switcher-icon">
            <i className="ic ic-calendar-clock ic-24px"></i>
            {type === this.state.filterBy[0] &&
            <ReactCSSTransitionGroup transitionName="selection-animation" transitionAppear={true}
                                     transitionAppearTimeout={0} transitionEnterTimeout={0} transitionLeaveTimeout={0}>
              <i className="ic ic-selected-dot ic-10px selected-icon"></i>
            </ReactCSSTransitionGroup>}
            {type === this.state.filterBy[0] && this.state.filterBy[1] === 'asc' &&
            <i className="ic ic-sort-asc ic-10px sort-icon"></i>}
            {type === this.state.filterBy[0] && this.state.filterBy[1] === 'desc' &&
            <i className="ic ic-sort-desc ic-10px sort-icon"></i>}
          </span>);
      }

      case 'alphabet': {

        return (
          <span className="switcher-icon">
            <i className="ic ic-abc ic-24px"></i>
            {type === this.state.filterBy[0] &&
            <ReactCSSTransitionGroup transitionName="selection-animation" transitionAppear={true}
                                     transitionAppearTimeout={0} transitionEnterTimeout={0} transitionLeaveTimeout={0}>
              <i className="ic ic-selected-dot ic-10px selected-icon"></i>
            </ReactCSSTransitionGroup>}
            {type === this.state.filterBy[0] && this.state.filterBy[1] === 'asc' &&
            <i className="ic ic-sort-asc ic-10px sort-icon"></i>}
            {type === this.state.filterBy[0] && this.state.filterBy[1] === 'desc' &&
            <i className="ic ic-sort-desc ic-10px sort-icon"></i>}
          </span>);
      }

      case 'channel': {

        return (
          <span className="switcher-icon">
            <i className="ic ic-channel ic-24px"></i>
            {type === this.state.filterBy[0] &&
            <ReactCSSTransitionGroup transitionName="selection-animation" transitionAppear={true}
                                     transitionAppearTimeout={0} transitionEnterTimeout={0} transitionLeaveTimeout={0}>
              <i className="ic ic-selected-dot ic-10px selected-icon"></i>
            </ReactCSSTransitionGroup>}
            {/*{type === this.state.filterBy[0] && this.state.filterBy[1] === 'asc' && <i className="ic ic-sort-asc ic-10px sort-icon"></i>}*/}
            {/*{type === this.state.filterBy[0] && this.state.filterBy[1] === 'desc' && <i className="ic ic-sort-desc ic-10px sort-icon"></i>}*/}
          </span>);
      }

      default: {

        return null;
      }
    }
  }

  _renderFilters() {
    let filters = this.state.filters;

    return filters.map((filter, index) => {

      return (
        <li key={filter + '_' + index} className="h-rmenu-col block radius bg-black"
            onClick={this._setFilter.bind(this, filter)}>
          <Tooltip
            placement="top"
            destroyTooltipOnHide={true}
            overlay={<div className="rc-tooltip rc-tooltip-placement-top block-note bg-black radius p-">
              <Translate content={`npvr.filters.${filter}`} />
            </div>}>
            <a href="javascript:void(0)" className="hover">
              {this.__renderFilter(filter)}
            </a>
          </Tooltip>
        </li>
      );
    });
  }

  _renderRecords() {
    let type = this.state.filterBy[0];
    let records = _get(this.state, 'records', []).filter((record) => {

      return !this.state.searchTerm
        || (_get(record, 'epg_program.title', '').toLowerCase().indexOf(this.state.searchTerm.toLocaleLowerCase()) !== -1)
        || (_get(record, 'title', '').toLowerCase().indexOf(this.state.searchTerm.toLocaleLowerCase()) !== -1)
        || (_get(record, 'epg_program.description', '').toLowerCase().indexOf(this.state.searchTerm.toLocaleLowerCase()) !== -1);
    });

    switch (this.state.filterBy[0]) {
      case 'status':

        records = _sortBy(_map(_groupBy(records, 'state'), (v, k) => [k, v]), 0);

        if (this.state.filterBy[1] === 'desc') {

          records = _reverse(records);
        }

        return _map(records, function (pairs, index) {

          return <ShowcaseNpvr key={'records_' + pairs[0] + '_' + index} id={'records_' + pairs[0] + '_' + index}
                               type={type} meta={{title: STATE_TO_TITLE[pairs[0]]}}
                               records={_orderBy(pairs[1], ['schedule_time', 'asc'], ['start_time', 'asc'])} />;
        });

      case 'date':
        records = _sortBy(_map(_groupBy(records, '_date'), (v, k) => [k, v]), 0);

        if (this.state.filterBy[1] === 'desc') {

          records = _reverse(records);
        }

        return _map(records, function (pairs, index) {
          let title = moment(pairs[0], "YYYYMMDD");

          return <ShowcaseNpvr key={'records_' + pairs[0] + '_' + index} id={'records_' + pairs[0] + '_' + index}
                               type={type} meta={{title: title}}
                               records={_orderBy(pairs[1], ['schedule_time', 'asc'], ['start_time', 'asc'])} />;
        });

        return [];

      case 'alphabet':
        records = _sortBy(_map(_groupBy(records, '_letter'), (v, k) => [k, v]), 0);

        if (this.state.filterBy[1] === 'desc') {

          records = _reverse(records);
        }

        return _map(records, function (pairs, index) {

          return <ShowcaseNpvr key={'records_' + pairs[0] + '_' + index} id={'records_' + pairs[0] + '_' + index}
                               type={type} meta={{title: pairs[0].toUpperCase()}}
                               records={_orderBy(pairs[1], ['schedule_time', 'asc'], ['start_time', 'asc'])} />;
        });

        return [];

      case 'channel':
        records = _sortBy(_map(_groupBy(records, 'channel_id'), (v, k) => [k, v]), 0);

        //if (this.state.filterBy[1] === 'desc') {
        //
        //  records = _reverse(records);
        //}

        return _map(records, function (pairs, index) {

          return <ShowcaseNpvr key={'records_' + pairs[0] + '_' + index} id={'records_' + pairs[0] + '_' + index}
                               type={type} meta={{channel_id: pairs[0]}}
                               records={_orderBy(pairs[1], ['schedule_time', 'asc'], ['start_time', 'asc'])} />;
        });

        return [];

      default:

        return <ShowcaseNpvr key="records_all" id="records_all" type={'default'} meta={{title: 'All'}}
                             records={_orderBy(records, ['schedule_time', 'asc'], ['start_time', 'asc'])} />;
    }

  }

  render() {

    const limitColorClass = Classnames({
      'error': this.state.records.length >= this.props.npvrLimit,
      'warning':  this.state.records.length / this.props.npvrLimit > 0.6 && this.state.records.length < this.props.npvrLimit
    });

    return (<DocumentTitle title={Translate.translator('page.records')}>
      <div className="npvr-showcase">
        <div className="blocks-row clearfix">
          <ul className="h-rmenu menu block col-last" style={{width: '100%'}}>
            <li className="h-rmenu-col block radius bg-black search-open">
              <a className="h-rmenu-search-link hover pointer" style={{left: 0}}>
                <i className="ic ic-search-rev ic-24px"></i>
              </a>
              <form className="h-rmenu-search-active __active" style={{left: '63px'}}>
                <input autoFocus type="text" placeholder="Keywords" id="npvr-search"
                       onChange={this._onSearchTermChange.bind(this)}
                       value={this.state.searchTermInput}
                />
                <a href="javascript:void(0)" className="mw-show pad-lr hover">
                  <span className="block-note"></span>
                </a>
              </form>
            </li>
            {this._renderFilters()}
            {this.props.npvrLimit &&
              <li className="h-rmenu-col block-2 radius bg-black col-last float-right crow no-gutter">
                <Tooltip
                  placement="top"
                  destroyTooltipOnHide={true}
                  overlay={<div className="rc-tooltip rc-tooltip-placement-top block-note bg-black radius p-" style={{width: '200px', whiteSpace: 'normal'}}>
                    <Translate content={`npvr.limit_desc${this.state.records.length >= this.props.npvrLimit && '_reached' || this.state.records.length / this.props.npvrLimit > 0.6 && '_warning' || '' }`} />
                  </div>}>
                  <strong>
                    <Translate content="npvr.usage" />:
                    <span className={limitColorClass}>
                      {' ' + this.state.records.length + ' / ' + this.props.npvrLimit}
                    </span>
                  </strong>
                </Tooltip>
              </li>
            }
          </ul>
        </div>
        {this._renderRecords()}
        {!this.state.records.length && <div id="showcase-empty-container">
          <div className="ui dimmer visible active radius">
            <div className="content">
              <div className="center">
                <h2 className="ui inverted icon header">
                  <Translate content="empty_section" />
                </h2>
              </div>
            </div>
          </div>
        </div>}
      </div>
    </DocumentTitle>);
  }
}

NpvrRoute.propTypes = {
  records: PropTypes.array
};

const mapStateToProps = ({npvr: {records}, auth: {user}}, ownProps) => {
  const channelIds = _uniq(_map(records.collection, 'channel_id'));

  const npvrLimit = _get(user, 'data.npvr_limit') ? '' + _get(user, 'data.npvr_limit') : null;

  return {
    records: _get(records, 'collection', []),
    channelIds: channelIds,
    npvrLimit
  };
};

export default connect(mapStateToProps, (dispatcher) => {
  return bindActionCreators({FetchAssetByIds, GetAllRecords}, dispatcher)
})(NpvrRoute);



// WEBPACK FOOTER //
// ./src/routes/npvr-route.js